declare namespace $ {

	type $mol_text__text_shm_ba_dashboard_indicators_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_check_box__title_shm_ba_dashboard_indicators_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_ba_dashboard_indicators_3 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['all_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_ba_dashboard_indicators_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_ba_dashboard_indicators_5 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['indicator_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_drop__allow_shm_ba_dashboard_indicators_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_drop['allow'] >
	>
	type $mol_drop__adopt_shm_ba_dashboard_indicators_7 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['indicator_adopt'] >
		,
		ReturnType< $mol_drop['adopt'] >
	>
	type $mol_drop__receive_shm_ba_dashboard_indicators_8 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['indicator_receive_end'] >
		,
		ReturnType< $mol_drop['receive'] >
	>
	type $mol_drop__Sub_shm_ba_dashboard_indicators_9 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['Indicators'] >
		,
		ReturnType< $mol_drop['Sub'] >
	>
	type $mol_view__sub_shm_ba_dashboard_indicators_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_dashboard_indicators_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_drop__allow_shm_ba_dashboard_indicators_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_drop['allow'] >
	>
	type $mol_drop__adopt_shm_ba_dashboard_indicators_13 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['indicator_adopt'] >
		,
		ReturnType< $mol_drop['adopt'] >
	>
	type $mol_drop__receive_shm_ba_dashboard_indicators_14 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['indicator_receive_before'] >
		,
		ReturnType< $mol_drop['receive'] >
	>
	type $mol_drop__Sub_shm_ba_dashboard_indicators_15 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['Indicator_content'] >
		,
		ReturnType< $mol_drop['Sub'] >
	>
	type $mol_drag__allow_copy_shm_ba_dashboard_indicators_16 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_drag['allow_copy'] >
	>
	type $mol_drag__allow_link_shm_ba_dashboard_indicators_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_drag['allow_link'] >
	>
	type $mol_drag__transfer_shm_ba_dashboard_indicators_18 = $mol_type_enforce<
		({ 
			'text/plain': ReturnType< $shm_ba_dashboard_indicators['indicator_transfer'] >,
		})  & ReturnType< $mol_drag['transfer'] >
		,
		ReturnType< $mol_drag['transfer'] >
	>
	type $mol_drag__Sub_shm_ba_dashboard_indicators_19 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['Indicator_drop'] >
		,
		ReturnType< $mol_drag['Sub'] >
	>
	type $mol_check_box__title_shm_ba_dashboard_indicators_20 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['indicator_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_ba_dashboard_indicators_21 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard_indicators['indicator_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_ba_dashboard_indicators extends $mol_pick {
		Menu_trigger_icon( ): $mol_icon_settings
		Menu_title( ): $mol_text
		all_checked( next?: boolean ): boolean
		All( ): $mol_check_box
		Menu_head( ): $mol_view
		indicator_adopt( next?: any ): any
		indicator_receive_end( next?: any ): any
		indicator_rows( ): readonly($mol_view)[]
		Indicators( ): $mol_list
		Indicators_drop( ): $mol_drop
		Menu_content( ): $mol_view
		indicator_transfer( id: any): string
		indicator_receive_before( id: any, next?: any ): any
		Indicator_drag_icon( id: any): $mol_icon_drag_vertical
		Indicator_content( id: any): $mol_view
		Indicator_drop( id: any): $mol_drop
		indicator_title( id: any): string
		indicator_checked( id: any, next?: boolean ): boolean
		dashboard_id( ): string
		options( ): readonly(string)[]
		selected( next?: readonly(string)[] ): readonly(string)[]
		align( ): string
		hint( ): string
		trigger_content( ): readonly(any)[]
		bubble_content( ): readonly(any)[]
		indicator_order( next?: readonly(string)[] ): readonly(string)[]
		Indicator_row( id: any): $mol_drag
		Indicator( id: any): $mol_check_box
	}
	
}

//# sourceMappingURL=indicators.view.tree.d.ts.map